/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";
import { useIntl } from "react-intl";
import { PageLink, PageTitle } from "../../components/layout/core";

const cabinetBreadCrumbs: Array<PageLink> = [
  {
    title: "Barcha shikoyatlar",
    path: "/",
    isSeparator: false,
    isActive: false,
  },
];

const Reports: FC = () => {
  const intl = useIntl();
  return (
    <>
      <PageTitle
        description="Kelib tushgan barcha shikoyatlar ro‘yxati"
        breadcrumbs={cabinetBreadCrumbs}
      />
      <h1>methodist</h1>
    </>
  );
};

export { Reports };
